import $ from 'jquery';
import {initWorkContentWysiwyg, initWysiwyg} from './wysiwyg';
import {showFormResponse} from "../common/json-response";
import {showDependsParams} from '../cabinet/show-custom-fields-params';
import initDeleteCustomWorkColumns  from '../cabinet/delete-custom-work-columns';
import { refreshCustomTableMultiselectLabels } from '../cabinet/custom-table-multiselect';
import {
  initImagesUploadCropper,
  initVideosUpload,
  initAudiosUpload,
  initDocumentsUpload,
  initAnyFileUpload,
} from '../cabinet/upload';
import { bindWbUploadDropzones } from '../wb-embed-ui';

export default function() {
  const addButtons = document.querySelectorAll('.add_custom_work_column');
  const statusWrapper = document.querySelector('.action-status-messages');

  const addHandler = function (e) {
    e.preventDefault();
    const fieldUuid   = e.target.getAttribute('data-custom-field-uuid');
    const workFieldUuid   = e.target.getAttribute('data-custom-work-field-uuid');
    const fieldFormat = e.target.getAttribute('data-custom-field-format');
    const workFieldUuidAttr = '[data-uuid="' + workFieldUuid + '"]';
    const fieldFormatAttr = '[data-type="' + fieldFormat + '"]';

    const workColumnsBlockSelector = '.custom_work_field' + workFieldUuidAttr + fieldFormatAttr + ' .columns-block-body';
    const workColumnsBlock = document.querySelector(workColumnsBlockSelector);

    let url = e.target.getAttribute('data-add-url');
    url = url + '?fieldUuid=' + fieldUuid + '&fieldFormat=' + fieldFormat + '&workFieldUuid=' + workFieldUuid;

    $.ajax({
      type: "GET",
      url: url,
      dataType: 'json',
      success: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else if (data.html) {
          workColumnsBlock.insertAdjacentHTML('beforeEnd', data.html);
          initWorkContentWysiwyg();
          initWysiwyg();
          showDependsParams();
          initDeleteCustomWorkColumns();
          initVideosUpload();
          initAudiosUpload();
          initDocumentsUpload();
          initAnyFileUpload();
          initImagesUploadCropper();
          bindWbUploadDropzones(workColumnsBlock);
          refreshCustomTableMultiselectLabels();
        }
      },
      error: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else {
          const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
          const statusMsg = document.createElement('div');
          statusMsg.classList.add(['alert']);
          statusMsg.classList.add(['alert_error']);
          statusMsg.innerHTML = message;
          statusWrapper.appendChild(statusMsg);
        }
      },
    });
  };

  addButtons?.forEach(function (button) {
    button.addEventListener('click', addHandler);
  });
}
